import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {BsDiamondFill, BsFillInfoSquareFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import {requester} from "../../../services/requester";

export const SettlementDealCompany = ({
                                          company,
                                          bullstat,
                                          settlement_ekatte,
                                          year,
                                          modalInfoHandler

                                      }) => {
    const [sumDeals, setSumDeals] = useState(0);
    const [sumOthers, setSumOthers] = useState(0);
    const [sumOthersAlternative, setSumOthersAlternative] = useState(0);
    const [sumDrawing, setSumDrawing] = useState(0);
    const [sumForDrawing, setSumForDrawing] = useState(0);
    const request = requester();

    useEffect(() => {
        Promise.all([
            request.get(`${baseUrl()}/deals/${year}/${settlement_ekatte}/${bullstat}/sum`),
            request.get(`${baseUrl()}/others/${year}/${settlement_ekatte}/${bullstat}`),
            request.get(`${baseUrl()}/drawings/${year}/${settlement_ekatte}/${bullstat}/sum`)
        ])
            .then(([dataSumDeals, dataSumOthers, dataSumDrawing]) => {

                let dataSumOthersTotal = null;
                let dataSumOthersAlternative = null;
                if (dataSumOthers !== undefined) {
                    dataSumOthersTotal = dataSumOthers.total;
                    dataSumOthersAlternative = dataSumOthers.white_spots + dataSumOthers.roads;
                }

                setSumDeals(dataSumDeals.sum_deals);
                setSumOthers(dataSumOthersTotal);
                setSumOthersAlternative(dataSumOthersAlternative);
                setSumDrawing(dataSumDrawing.sum_drawings);
                setSumForDrawing(dataSumDeals.sum_deals);

                if (dataSumOthersTotal) {
                    setSumForDrawing(state => state + dataSumOthersTotal);
                }
            })
    }, [year, settlement_ekatte]);

    const showInfo = () => {
        modalInfoHandler(company);
    };

    let isStartedDrawing = false;
    isStartedDrawing = sumDrawing > 0.01;

    let drawingDiff = sumForDrawing;
    if (isStartedDrawing) {
        drawingDiff = sumForDrawing - sumDrawing;
    }

    const Status = () => {
        if (drawingDiff > 1) {
            return <td style={{color: "darkorange"}}><BsDiamondFill/></td>;
        } else if (drawingDiff < 0) {
            return <td style={{color: "var(--app-danger-fg)"}}><BsDiamondFill/></td>;
        } else {
            return <td style={{color: "var(--app-info-fg)"}}><BsDiamondFill/></td>;
        }
    }

    return (
        <>
            {isStartedDrawing ? (
                <tr style={{background: "var(--app-surface-2)"}}>
                    <td style={{color: "var(--app-gold)"}}><BsFillInfoSquareFill onClick={showInfo} data-bs-toggle="modal"
                                                                         data-bs-target="#companyInfoModal"/></td>
                    <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}}
                              to={`/info/${year}/${settlement_ekatte}/${bullstat}`}>{company.company_name}</Link></td>
                    <td>{bullstat}</td>
                    <td>няма данни</td>
                    <td>няма данни</td>
                    <td>няма данни</td>
                    <td>{sumDeals?.toFixed(2)}</td>
                    <td>{sumOthersAlternative ? sumOthersAlternative.toFixed(2) : null}</td>
                    <td>{sumForDrawing?.toFixed(2)}</td>
                    <td>{sumDrawing ? sumDrawing.toFixed(2) : null}</td>
                    <Status/>
                </tr>
            ) : (
                <tr>
                    <td style={{color: "var(--app-gold)"}}><BsFillInfoSquareFill onClick={showInfo} data-bs-toggle="modal"
                                                                         data-bs-target="#companyInfoModal"/></td>
                    <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}}
                              to={`/info/${year}/${settlement_ekatte}/${bullstat}`}>{company.company_name}</Link></td>
                    <td>{bullstat}</td>
                    <td>няма данни</td>
                    <td>няма данни</td>
                    <td>няма данни</td>
                    <td>{sumDeals?.toFixed(2)}</td>
                    <td>{sumOthersAlternative ? sumOthersAlternative.toFixed(2) : null}</td>
                    <td>{sumForDrawing?.toFixed(2)}</td>
                    <td>{sumDrawing ? sumDrawing.toFixed(2) : null}</td>
                    <Status/>
                </tr>
            )}


        </>)
}